import { Injectable } from '@angular/core';
@Injectable()
export class CustomValidatorsService {
 
    static numberOnly(event: any) {
        return (event.charCode == 13 || (event.charCode >= 48 && event.charCode <= 57));
    }
 
    static serialNumberMasking(sno) {
        return /^\d{4}-\d{9}-\d{6}$/.test(sno);
    }
}
